import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useOrganization } from "../context/OrganizationContext";
import { toast } from "react-toastify";

export default function SelectOrganizationPage() {
  const { orgs, setActiveOrgId, createOrg } = useOrganization();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const choose = (id: number) => {
    setActiveOrgId(id);
    navigate("/documents", { replace: true });
  };

  const handleCreate = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    if (!name.trim()) {
      setError("Organization name is required");
      toast.error("Organization name is required");
      return;
    }
    setSubmitting(true);
    try {
      await createOrg(name.trim());
      toast.success("Organization created.");
    navigate("/documents", { replace: true });
    } catch (err: any) {
      setError(err?.message || "Unable to create organization");
      toast.error(err?.message || "Unable to create organization");
    } finally {
      setSubmitting(false);
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-6">
      <div className="card w-full max-w-md p-8">
        <h1 className="font-display text-2xl font-semibold text-ink">
          {orgs.length ? "Choose an organization" : "Create your first organization"}
        </h1>
        <p className="mt-1 text-sm text-slate-500">
          {orgs.length
            ? "Pick which organization to work in, or create a new one."
            : "Organizations keep each business's invoices and data separate."}
        </p>

        {orgs.length > 0 && (
          <ul className="mt-6 grid gap-2">
            {orgs.map((org) => (
              <li key={org.id}>
                <button
                  type="button"
                  className="button-secondary w-full justify-between"
                  onClick={() => choose(org.id)}
                >
                  <span>{org.name}</span>
                  <span className="text-xs text-slate-400">{org.role}</span>
                </button>
              </li>
            ))}
          </ul>
        )}

        <form className="mt-6 grid gap-3 border-t border-slate-200 pt-6" onSubmit={handleCreate}>
          <label className="grid gap-1 text-sm font-medium text-slate-600">
            New organization name
            <input
              type="text"
              className="input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Acme Consulting"
            />
          </label>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <button type="submit" className="button" disabled={submitting}>
            {submitting ? "Creating…" : "Create organization"}
          </button>
        </form>

        <button
          type="button"
          className="mt-4 text-sm text-slate-500 hover:text-slate-700"
          onClick={handleLogout}
        >
          Log out
        </button>
      </div>
    </div>
  );
}
